import type { UserManager } from 'oidc-client-ts';
import type { Market } from '@//config/domain-locale-map';

const CLIENT_ROOT = typeof window === 'object' ? window.location.origin : '/';

const REDIRECT_PATH_SIGN_IN = '/oidc/signin';
const REDIRECT_PATH_SIGN_OUT = '/oidc/signout';

const OIDC_AUTHORITIES = {
  WAYKE: process.env.NEXT_PUBLIC_OIDC_AUTHORITY_WAYKE,
  DRIVE: process.env.NEXT_PUBLIC_OIDC_AUTHORITY_DRIVE,
};

let userManager: UserManager | undefined;

export const createUserManager = async (market: Market): Promise<UserManager> => {
  const authority = OIDC_AUTHORITIES[market.toUpperCase() as keyof typeof OIDC_AUTHORITIES];
  if (!authority) throw new Error(`Issuer not found for market: ${market}`);
  const client_id = process.env.NEXT_PUBLIC_OIDC_CLIENT_ID;
  if (!client_id) throw new Error(`Client ID not found for market`);
  const response_type = process.env.NEXT_PUBLIC_OIDC_RESPONSE_TYPE;
  if (!response_type) throw new Error(`Response type not found for market`);
  const scope = process.env.NEXT_PUBLIC_OIDC_SCOPE;
  if (!scope) throw new Error(`Scope not found for market`);

  const { UserManager, WebStorageStateStore } = await import('oidc-client-ts');

  userManager = new UserManager({
    authority,
    client_id,
    response_type,
    scope,
    redirect_uri: `${CLIENT_ROOT}${REDIRECT_PATH_SIGN_IN}`,
    post_logout_redirect_uri: `${CLIENT_ROOT}${REDIRECT_PATH_SIGN_OUT}`,
    loadUserInfo: false,
    automaticSilentRenew: true,
    userStore:
      typeof window === 'object'
        ? new WebStorageStateStore({
            store: window.localStorage,
            prefix: `oidc.${market}.`,
          })
        : undefined,
    stateStore:
      typeof window === 'object'
        ? new WebStorageStateStore({
            store: window.localStorage,
            prefix: `oidc.${market}.`,
          })
        : undefined,
    acr_values: 'source:web-ui-app',
  });
  return userManager;
};

export const getUserManager = (): UserManager => {
  if (!userManager) {
    throw new Error(
      'UserManager is not initialized. Please call createUserManager with a valid market first.',
    );
  }
  return userManager;
};
